import { ColumnFiltersState } from '@tanstack/react-table';

export const getEventTypeFilter: (columnFilters: ColumnFiltersState) => string | undefined = (
  columnFilters: ColumnFiltersState
) => {
  if (columnFilters.length === 0) {
    return undefined;
  }
  const typeFilter = columnFilters.find(cf => cf.id === 'type');
  if (typeFilter && typeFilter.value) {
    return typeFilter.value as string;
  }
  return undefined;
};

export const getSourceTypeFilter: (columnFilters: ColumnFiltersState) => string | undefined = (
  columnFilters: ColumnFiltersState
) => {
  if (columnFilters.length === 0) {
    return undefined;
  }
  const typeFilter = columnFilters.find(cf => cf.id === 'sourcePath');
  if (typeFilter && typeFilter.value) {
    return typeFilter.value as string;
  }
  return undefined;
};
